import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getToken, removeToken, isTokenExpired } from '../utils/helpers';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    
    if (token) {
      // Check if token is expired
      if (isTokenExpired(token)) {
        removeToken();
        window.location.href = '/login';
        return Promise.reject(new Error('Token expired'));
      }
      
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      removeToken();
      window.location.href = '/login';
    }
    
    if (error.response?.status === 403) {
      // Forbidden - show error
      console.error('Access forbidden');
    }
    
    return Promise.reject(error);
  }
);

export default api;
